module.exports = __webpack_public_path__ + "img/31200.8d40bd28.jpg";